'use strict';

import {
  checkImageExists,
  findSelectionAndCrmData,
  isCompareMode,
  isStringHasChars, setCSSVar,
  userPrevent
} from '../../functions';
import {
  addAmenitiesOfBuilding,
  addApartmentNameWithNumber,
  addInfopointsBlock, addTechnicalSpecifications, closeOptionsCard, createHeader
} from "./cardsFunctions";
import {
  Buildings,
  cardsData,
  components,
  isDesktop,
  isMobile,
  isNoMenu,
  projectMode,
  settingsData,
  UIRoot
} from '../../settings';
import {applyNowContent} from "../components/apply-now/applyNowContent";
import printJS from "print-js";
import {CardTypes, ViewMode} from "../../common";
import {TraverseSwitcher} from "../components/TraverseSwitcher/TraverseSwitcher";
import {Disclaimer} from '../components/Disclaimer/Disclaimer';
import {OptionsCardGallery} from "../components/OptionsCardGallery/OptionsCardGallery";
import {Prepayment} from "../components/Prepayment/Prepayment";
import {Button} from "../interfaces/buttons/Button";
import {UnitCardClass} from './unitCards/UnitCardClass';
import {BaseElement} from "../interfaces/BaseElement";
import {changeLangToCurrent, getCurrentLang, getCurrentLangDirection} from '../components/langSwitcher/langSwitcher';
import {applyNow} from "../components/apply-now/applyNow";
import {hideTooltip} from "../components/flatTooltip/flatTooltip";
import {
  draggableOptionsCardBlock,
  fixedElementsPositionDurScrolling,
  openOptionsCardAnimation
} from "./cardsAnimation";
import {createIconsArray} from "./cardsConfig";
import {SwipeScript} from "../controls/swipe";
import {zoom} from "../../libs/directive";
import {findSimilarApartments} from "../menu/search/similarSearch";
import {analytics} from "../analytics/analytics";
import {setActiveLordIcon, setLordIcon} from '../../lordicon';
import {renderUpdateValuesOnDemand} from "../../app";
import {
  addAdditionalButtons, addBmbyEditButton, floorPlanHandler,
  hideAbsentInConfigUnitCardInfoPoints
} from './unitCards/unitCardFunctions';
import gsap from "gsap";
import { conferenceStatistic } from '../analytics/conferenceStatistic';
import { openSearchHandler } from '../menu/search/search';
import { Vantages } from '../components/vantage/Vantage';
import {hideAsideContainer, logoHandler} from "../menu/menu";
import { addStatisticTimeOut, showStatisticPopUp } from '../analytics/statistic';
import { Cloudflare } from '../api/Cloudflare';
import {CustomerContactNow} from "../menu/contactUs/CustomerContactNow";
import {GetElement} from "../interfaces/GetElement";
import { Paint } from './Paint';
import {StaticPrepayment} from "../components/StaticPrepayment";
import { BmbyMode } from '../mode/BmbyMode';
import {Amenities} from "../components/Amenities/Amenities";
import {OptionsCardViewer} from "./OptionsCardViewer";

let optionCardGallery = null;
let vantageSwitcher = null;

export const openOptionsCard = (args = {}) => {
  let {
    object = settingsData.lastClickedFlat.userData.crm_data,
    isForCompare = false,
    isSimilarApartment = false,
    settings = config,
    params = {}
  } = args;

  analytics('option card', object);
  cardsData.cardMode.isAmenities = settingsData.lastClickedFlat.userData?.customSelection || object?.isAmenity;
  hideTooltip();

  document.querySelector('#threejs > .disclaimer')?.classList.add('hidden');

  if (!isForCompare) {
    const optionsCard = UIRoot.querySelector(`.${CardTypes.Options}-card`);
    const compareBlock = document.querySelector('.compare-block');
    if (compareBlock) {
      compareBlock.parentElement.removeChild(compareBlock);
    } else if (optionsCard) {
      optionsCard.parentElement.removeChild(optionsCard);
    }
  }

  createOptionsCard({object, settings, isForCompare});

  setCSSVar(
      '--optionsCardPlansBoxWidth',
      `${Math.round(new GetElement('.options-card__plans-box').width)}px`
  );

  const flatId = object?.bmbyPropID || settingsData?.lastClickedFlat?.userData?.name
  if (!isForCompare && flatId)
    projectMode.Pagination.paginate({
      source: 'openOptionsCard',
      flatId: flatId,
      isSimilarApartment
    });

  if (isNoMenu)
    document.querySelector('.button-modes--back[data-button="back"]')?.classList.add('hidden');

  if (isMobile) {
    document.querySelector('.additional-menu__container')?.classList.add('hidden');
    const floorSlider = document.querySelector('.fs__main__container');
    floorSlider && floorSlider.classList.add('hidden');
  }

  UnitCardClass.changeCurrentCardPosition();
  renderUpdateValuesOnDemand(true);
  UnitCardClass.applyOptionsCardRules();
  // toggleCardMainButton();
  if (isDesktop)
    hideAsideContainer();
  if (!isMobile)
    UnitCardClass.cards.forEach(card => card.html.classList.add('hidden'));
};

export const createOptionsCard = (args) => {
  let { object, settings, isForCompare } = args;
  const {selectedMesh} = findSelectionAndCrmData(object.engineId);
  if (selectedMesh)
    settingsData.lastClickedFlat = selectedMesh;

  let cardParent = UIRoot;
  if (isForCompare) {
    const compareCardWrapper = document.getElementsByClassName('compare-block__card');
    compareCardWrapper[0].children.length === 0 ?
      cardParent = compareCardWrapper[0] :
      cardParent = compareCardWrapper[1];
  }


  const cardBox = new BaseElement()
    .addClass(
      `${CardTypes.Options}-card`,
      'card',
      'non-canvas'
    )
    .addAttribute('data-engineid', object.engineId)
    .event('scroll', optionsCardScrollHandler)
    .appendTo(cardParent);
  if (!isMobile) {
    const nonCompareModeSettings = isDesktop ? `1fr 420px` : `420px 1fr`;
    const gridLayout = isCompareMode()
      ? 'initial'
      : nonCompareModeSettings;
    cardBox
      .addStyle('grid-template-columns', gridLayout);
  }
  if (cardsData.cardMode.isAmenities)
    cardBox.addClass('background-backdrop-filter', `${CardTypes.Amenities}-card`);
  if (isCompareMode())
    cardBox.addClass('compare-mode');
  if (isNoMenu)
    cardBox.addClass('no-menu-mode');

  cardsData.cardMode.isUnavailable = object.status !== 'Available';

  if (isMobile) {
    addOptionsCardSpoilerTo(cardBox.DOMElement, object);

    !cardsData.cardMode.isUnavailable && new BaseElement()
      .addClass(`${CardTypes.Options}-card__bumper`)
      .appendTo(cardBox.DOMElement);
  }

  addPlansBlock( {cardBox: cardBox.DOMElement, object} );

  if (!isCompareMode()) {
    new Button()
      .addClass('options-card__close-button', 'close-button-cross')
      .event('click', closeHandler)
      .appendTo(cardBox.DOMElement);
  }

  const cardBoxData = new BaseElement()
    .addClass(`${CardTypes.Options}-card__data`, isMobile && 'swipe-marker')
    .appendTo(cardBox.DOMElement)
    .DOMElement;

  addLogoToDataElement(cardBoxData, settings);
  createHeader(object, cardBoxData, settings, CardTypes.Options);

  if (isMobile)
    openOptionsCardAnimation();

  if (cardsData.cardMode.isAmenities) {
    addAmenityDescription(object);
    if (isMobile) {
      fixedElementsPositionDurScrolling();
      setPlansBlockBoundaries();
      openOptionsCardAnimation();
    } else {
      setOptionsCardPlansBlockHeight();
      setOptionsCardDataHeightInCssVar();
    }
    if (object.propNum === 'Floor plan' && (!config.features.specifications || config.features.specifications.active) && settingsData.specifications) {
      addTechnicalSpecifications(object, cardBoxData, CardTypes.Options, settings);
    }
    return cardBox.DOMElement;
  }

  addInfopointsBlock(object, cardBoxData, CardTypes.Options, settings);

  if (!isCompareMode() && !isMobile)
    addDragElement(cardBoxData);

  if (!isMobile) {
    const optionsCardsHeader = document.querySelectorAll(`.${CardTypes.Options}-card__header`);
    const isCardHeaderButtonsExists = Boolean(document.querySelector(`.${CardTypes.Options}-card__header-buttons`));
    const buttonsContainerParent = isCompareMode() && isCardHeaderButtonsExists
      ? optionsCardsHeader[1]
      : optionsCardsHeader[0];
    const buttonsContainer = new BaseElement()
      .addClass(`${CardTypes.Options}-card__header-buttons`)
      .appendTo(buttonsContainerParent)
      .DOMElement;

    addSwipeHandlers(cardBoxData);

    if (settingsData.isConferenceHost && !cardsData.cardMode.isAmenities)
      new StaticPrepayment(buttonsContainer, object);
    if (!cardsData.cardMode.isAmenities && !isCompareMode() && !settingsData.isConferenceHost)
      new Prepayment(buttonsContainer,object);
    if (!isCompareMode())
      new CustomerContactNow('option-card').appendTo(buttonsContainer);
    if (isCompareMode()) {
      const iconFloorPlan = object.assets.tours360 ? 'icon-360' : 'icon-plan-type';
      new Button("Explore")
        .addClass(
          `${CardTypes.Options}-card__button-floor-plan`, 'cards-buttons',
          iconFloorPlan,
          'cards-buttons',
          'button')
        .event('click', floorPlanHandler)
        .appendTo(buttonsContainer, 'beforeend')
    }

    addBmbyEditButton(object,buttonsContainer,CardTypes.Options,'beforeend');

    if (buttonsContainer.children.length === 0)
      buttonsContainer.remove();
  }

  if (isMobile) {
    fixedElementsPositionDurScrolling();
    setPlansBlockBoundaries();
  }

  addAdditionalButtons({card: cardBoxData, data: object, cardType: CardTypes.Options});

  if ((!config.features.specifications || config.features.specifications.active) && settingsData.specifications && !isCompareMode()) {
    addTechnicalSpecifications(object, cardBoxData, CardTypes.Options, settings);
  }

  addAmenitiesOfBuilding(cardBoxData);

  UnitCardClass.setUnitCardHeightIntoCssVar()
  findSimilarApartments();
  if (!isCompareMode()) {
    let timeOut;
    if (settingsData.isConferenceHost) {
      timeOut = setTimeout(() => conferenceStatistic( {cardBox: cardBox.DOMElement, object} ), 2000);
    } else {
      timeOut = setTimeout(() => showStatisticPopUp( {cardBox: cardBox.DOMElement, object} ), 2000);
    }
    
    addStatisticTimeOut(timeOut);
  }

  return cardBox.DOMElement;
};

function addLogoToDataElement(parent, settings) {
  if (OptionsCardViewer.active && !isMobile) {
    const logo = new BaseElement()
        .addClass('separate-card__logo')
        .appendTo(parent);

    new BaseElement('img')
        .addClass('logo__img')
        .addAttribute('src', Cloudflare.resize(settings.data.general.logo, {width: 300}))
        .appendTo(logo.DOMElement);
  }
}

function addAmenityDescription(object) {
  if (!object?.description)
    return;

  const descriptionData = object.description;
  const dataElement = document.querySelector('.options-card__data');
  const amenityDescription = new BaseElement('div')
    .addClass(`${CardTypes.Options}-card__amenity-description`, 'language-string')
  amenityDescription.innerHtml(changeLangToCurrent(descriptionData[getCurrentLang()]))
    .appendTo(dataElement);
  for (const key in descriptionData) {
    amenityDescription.addAttribute(`data-lang-${key}`, descriptionData[key])
  }
}

function addOptionsCardSpoilerTo(parent,object) {
  const spoiler = new BaseElement()
      .addClass(`${CardTypes.Options}-card__spoiler`, 'transparent-background', 'hidden')
      .appendTo(parent);

  addApartmentNameWithNumber(spoiler.DOMElement,object);

  new BaseElement('button')
      .addClass(`${CardTypes.Options}-card__back-button`, getCurrentLangDirection() === 'rtl' ? 'icon-right1' : 'icon-left1')
      .event('click', optionsCardBackButtonHandler)
      .appendTo(spoiler.DOMElement);
}

function optionsCardScrollHandler(event) {
  const spoilerElement = event.target.querySelector(`.${CardTypes.Options}-card__spoiler`);
  if (!spoilerElement)
    return;

  if (event.target.scrollTop < 40) {
    spoilerElement.classList.add('transparent-background');
  } else if (spoilerElement.classList.contains('transparent-background')) {
    spoilerElement.classList.remove('transparent-background');
  }
}

export const setOptionsCardDataHeightInCssVar = () => {
  const optionsCardData = document.querySelector('.options-card__data');
  const optionsCardDataHeight = optionsCardData.getBoundingClientRect().height;
  // document.querySelector(':root')
  //   .style.setProperty('--optionsCardDataHeight', `${optionsCardDataHeight}px`);
  setCSSVar('--optionsCardDataHeight', `${optionsCardDataHeight}px`);
}

const addSwipeHandlers = (cardBoxData) => {
  SwipeScript(cardBoxData);
  if (document.querySelector('html').getAttribute('dir') === 'rtl' || isDesktop) {
    cardBoxData.addEventListener('swiped-right', swipeRightDataHandler);
    cardBoxData.addEventListener('swiped-left', swipeLeftDataHandler);
  } else {
    cardBoxData.addEventListener('swiped-right', swipeLeftDataHandler);
    cardBoxData.addEventListener('swiped-left', swipeRightDataHandler);
  }
  cardBoxData.addEventListener('click', draggableOptionsCardBlock);
}

const addDragElement = (parent) => {
  return new BaseElement()
    .addClass(`${CardTypes.Options}-card__data-drag`)
    .appendTo(parent)
    .DOMElement;
}

export const setWidthOfCardDependingOnMenu = (card = document.getElementsByClassName(`${CardTypes.Options}-card`)) => {
  if (card.length === 0 || isMobile || BmbyMode.active)
    return;
  if (!card.length) {
    setWidth(card);
    return;
  }

  for (let i = 0; i < card.length; i++) {
    setWidth(card[i]);
  }
}

const setWidth = (card) => {
  if (!card)
    return;

  const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';
  const menuWidth = (isMobile || isDesktop)
    ? document.querySelector('.aside__container').getAttribute('data-initial-width')
    : 56;
  if (isDesktop) {
    card.style.right = `0`;
    card.style.left = `initial`;
  } else if (rtl) {
    isCompareMode() && !card.classList.contains('compare-block') || isNoMenu ?
      card.style.width = `100%` :
      card.style.width = `calc(100% - ${menuWidth}px)`;
    card.style.right = `initial`;
    card.style.left = `0`;
  } else {
    isCompareMode() && !card.classList.contains('compare-block') || isNoMenu ?
      card.style.width = `100%` :
      card.style.width = `calc(100% - ${menuWidth}px)`;
    card.style.right = `0`;
    card.style.left = `initial`;
  }
}

const addPlansBlock = async (args) => {
  const {cardBox, object} = args;

  const plansBlock = new BaseElement()
    .addClass(`${CardTypes.Options}-card__plans-box`)
    .appendTo(cardBox)
    .DOMElement;

  new BaseElement()
    .addClass(`${CardTypes.Options}-card__plans-box_preview`)
    .appendTo(plansBlock);

  const optionsCardButtons = new BaseElement()
    .addClass(`${CardTypes.Options}-card__plans-box_buttons`, !isMobile && 'background-backdrop-filter')
    .appendTo(plansBlock)
    .DOMElement;

  const plansData = addPlansData(object);
  let sortingArray = JSON.parse(JSON.stringify(plansData));
  sortingArray.sort((a,b) => {
    if (a.type === '360' || a.type === '360Sample') {
      return -1;
    }
    return 0;
  });

  await addPlansButtons( {object, plansData: sortingArray, parent: optionsCardButtons} );
  setPlansAndTours({cardBox, plansData: sortingArray} );
  setPlugToPreviewBlock(cardBox);
  togglePlans(cardBox);
  setOptionsCardButtonsWidthIntoCssVar();
  setInitialPlansButton(optionsCardButtons);

  isCompareMode() &&
  optionsCardButtons.querySelector('[data-type="2D"]')?.click();

  return sortingArray;

  // function shiftTargetViewInFront(arr, target) {
  //   arr.reverse();
  //   for (let i = 0; i < arr.length; i++) {
  //     if (arr[i].type === target) {
  //       const temp = arr[i];
  //       arr.splice(i, 1);
  //       arr.push(temp);
  //       arr.reverse();
  //       break;
  //     }
  //   }
  //   return arr;
  // }
};

function setInitialPlansButton(buttonsParent) {
  const initButtonName = config.features.apartments?.initialPlansButton;
  if (initButtonName && buttonsParent.children.length > 1) {
    const initButtonElement = buttonsParent.querySelector(`[data-type="${initButtonName}"]`);
    if (initButtonElement)
      initButtonElement.click();
  }
}

export const setPlansBlockBoundaries = () => {
    setOptionsCardPlansBlockHeight();
    setOptionsCardPlansBlockWidth();
}

export const setOptionsCardPlansBlockHeight = () => {
  if (!isMobile)
    return;

  const optionsCard = document.querySelector('.options-card');
  if (!optionsCard)
    return;

  const unitCard = document.querySelector('.unit-card');
  const unitCardHeight = unitCard ? unitCard.getBoundingClientRect().height : 0;
  const optionsCardData = optionsCard.querySelector('.options-card__data');
  const optionsCardDataHeight = optionsCardData ? optionsCardData.getBoundingClientRect().height : 0;
  const plansBlock = optionsCard.querySelector(`.${CardTypes.Options}-card__plans-box`);
  const plansBlockHeight = window.innerHeight - unitCardHeight - optionsCardDataHeight;
  UnitCardClass.setUnitCardHeightIntoCssVar();

  // document.querySelector(':root').style.setProperty('--plansBlockHeight', `${Math.ceil(plansBlockHeight)}px`);
  setCSSVar('--plansBlockHeight', `${Math.ceil(plansBlockHeight)}px`);
  isMobile && settingsData.isLandscape
    ? plansBlock.classList.remove('plans-block-height')
    : plansBlock.classList.add('plans-block-height');
}

const setOptionsCardPlansBlockWidth = () => {
  const optionsCard = document.querySelector('.options-card');
  if (!optionsCard)
    return;
  // const unitCard = document.querySelector('.unit-card');
  const plansBlock = document.querySelector(`.${CardTypes.Options}-card__plans-box`);
  // const unitCardWidth = unitCard ? unitCard.getBoundingClientRect().width : 0;

  const optionsCardData = optionsCard.querySelector('.options-card__data');
  const optionsCardDataWidth = optionsCardData.getBoundingClientRect().width;

  const plansBlockWidth = window.innerWidth - optionsCardDataWidth;
  // document.querySelector(':root').style.setProperty('--plansBlockWidth', `${plansBlockWidth}px`);
  setCSSVar('--plansBlockWidth', `${plansBlockWidth}px`);
  isMobile && !settingsData.isLandscape
    ? plansBlock.classList.remove('plans-block-width')
    : plansBlock.classList.add('plans-block-width');
}

export const setOptionsCardButtonsWidthIntoCssVar = () => {
  const optionsCardButtons = document.querySelector('.options-card__plans-box_buttons');
  if (!isMobile || !settingsData.isLandscape || !optionsCardButtons) {
    return;
  }

  const optionsCardButtonsWidth = optionsCardButtons.getBoundingClientRect().width;
  // document.querySelector(':root').style.setProperty('--optionsCardButtonsWidth', `${optionsCardButtonsWidth}px`);
  setCSSVar('--optionsCardButtonsWidth', `${optionsCardButtonsWidth}px`);
};

export const addPlansButtons = async (args) => {
  const {plansData, parent, object} = args;

  for (const button of plansData) {
    if (button.isActive && button.crmData) {
      const btn = new BaseElement('button')
        .addClass(
          `${button.type}`,
          `${CardTypes.Options}-card__plans-box_buttons-btn`
        )
        .addAttribute('data-type', button.type)
        .appendTo(parent);

      if (isMobile) {
        switch (button.type) {
          case '360Sample':
            btn.addClass('icon-360');
            addCardButtonTooltip(btn.DOMElement,'Sample');
            break;
          case '360':
            btn.addClass('icon-360');
            addCardButtonTooltip(btn.DOMElement,button.type);
            break;
          case 'gallery':
            btn.addClass('icon-gallery');
            addCardButtonTooltip(btn.DOMElement,button.type);
            break;
          case '2D':
          case 'keyPlan':
            btn.addClass('icon-plan-type');
            addCardButtonTooltip(btn.DOMElement,button.type);
            break;
          case 'vantage':
            btn.addClass('icon-vantage');
            addCardButtonTooltip(btn.DOMElement,button.type);
            break;
          case 'ruler':
            btn.addClass('icon-ruler');
            addCardButtonTooltip(btn.DOMElement,button.type);
            break;
          default:
            btn.addClass('icon-teddy');
            addCardButtonTooltip(btn.DOMElement,button.type);
            break;
        }
      } else {
        if (button.type === '360Sample') {
          setLordIcon('360View', btn.DOMElement, {
            stroke: 90,
            trigger: 'hover'
          }, 'afterbegin');
          addCardButtonTooltip(btn.DOMElement,'Sample')
        } else {
          if (button.icon) {
            btn
                .deleteAttribute('data-dictionary')
                .removeClass('language-string')
                .innerHtml('');
            setLordIcon(button.type, btn.DOMElement, {
              stroke: 90,
              trigger: 'hover'
            })
          } else {
            setLordIcon(button.type, btn.DOMElement, {
              stroke: 90,
              trigger: 'hover'
            });
          }

          addCardButtonTooltip(btn.DOMElement,button.type);
        }
      }

      if (button.type === 'vantage' && !isCompareMode()) {
        vantageSwitcher = new TraverseSwitcher();
      }
    }
  }

  const excludeBuildings = config.features.vantage?.excludeBuildings || [];
  const isVantageButtonActive = plansData.find(btn => btn?.type === 'vantage' && btn?.crmData?.length === 0 && btn?.isActive);
  const isNotPlug = !object.engineId.startsWith('zero');
  if (isNotPlug && isVantageButtonActive && !cardsData.cardMode.isAmenities && !excludeBuildings.includes(object.buildingEngineId)) {
      new Vantages(object.buildingEngineId).addButton(parent);
  }

  addActiveClassToBtnTogglersPlans(parent);
  if (!parent.closest('.compare-block') && isDesktop)
    addBackButton(parent);
};

const appearPlansButtonAnimation = (button) => {
  if (!button.classList.contains('hidden'))
    return;

  let fromPoint = settingsData.isLandscape
    ? -200
    : 200;

    gsap.fromTo(
      button,
      {x: fromPoint},
      {
        x: 0,
        duration: settingsData.animationsDuration,
        onStart: () => {
          button.classList.remove('hidden');
        }
      }
    );
}

const allPlansButtonsDisappear = () => {
  const allPlansButtons = [...document.querySelectorAll(`.${CardTypes.Options}-card__plans-box_buttons-btn`)];
  allPlansButtons.forEach(button => {
    disappearPlansButtonsAnimation(button);
  })
}

const disappearPlansButtonsAnimation = (button) => {
  if (button.classList.contains('hidden'))
    return;

  let toPoint = settingsData.isLandscape
    ? -200
    : 200;

  gsap.fromTo(
    button,
    {x: 0},
    {
      x: toPoint,
      duration: settingsData.animationsDuration,
      onComplete: () => {
        button.classList.add('hidden');
      }
    }
  );
}

const setPlansAndTours = (args) => {
  const {cardBox, plansData} = args;
  const block = cardBox.querySelector(`.${CardTypes.Options}-card__plans-box_preview`);
  const togglerButton = cardBox.querySelector(`.${CardTypes.Options}-card__plans-box_buttons-btn`);
  const loader = cardBox.querySelector(`.${CardTypes.Options}-card__plans-box_preview-loader`);

  if (loader)
    block.removeChild(loader);
  createPlanPreviewElement( {cardBox, element: togglerButton, block, plansData} );
}

export const createPlanPreviewElement = (args) => {
  const {cardBox, element, block, plansData} = args;
  if (!plansData || !element)
    return;

  if (element.classList.contains('vantage-mode-btn')) {
    const evt = new Event('click');
    element.dispatchEvent(evt);
    return;
  }

  if (element && element.classList.contains('print')
    || element && element.classList.contains('download')
    || element.classList.contains('plan-back_btn'))
      return;

  addDisclaimer(cardBox, element);

  if (element.getAttribute('data-type') === 'gallery') {
    block.innerHTML = '';
    block.classList.remove('zoom');
    block.classList.remove('is-padding');
    let pictures = plansData.find(assets => assets.type === 'gallery').crmData;

    // if (pictures.length > 1 && pictures.length < 4)
    //   pictures = pictures.concat(pictures);

    new OptionsCardGallery(block, pictures)
        .create();

    return;
  }

  const src = new URL(plansData.find(data => data.type === element.getAttribute('data-type')).crmData);
  block.innerHTML = '';

  if (src.origin.match(/matterport/g)) {
    src.searchParams.append('play', '1');

    if (isMobile) {
      src.searchParams.append('brand', '0');
      src.searchParams.append('title', '0');
    }
  }

  const preview = new BaseElement((element.getAttribute('data-type') === '2D' ||element.getAttribute('data-type') === 'keyPlan') ? 'img' : 'iframe')
    .addClass(`${CardTypes.Options}-card__plans-box_preview-content`, `plan-${element.getAttribute('data-type')}`)
    .appendTo(block);

  if (element.getAttribute('data-type') === '2D' || element.getAttribute('data-type') === 'keyPlan') {
    // Do check in case of SVG file
    const srcString = src.toString();
    const planURL = srcString.endsWith(".svg")
        ? srcString
        : Cloudflare.resize(srcString, { width: isMobile ? 2048 : 4096 });
    preview
        .event('click', (event) => {
          if (!isCompareMode() || event.detail > 1)
            return;

          const popUp = new BaseElement()
              .addClass(`${CardTypes.Options}-card__plan-pop-up`, 'background-backdrop-filter')
              .appendTo(document.body);

          new Button()
              .addClass(`${CardTypes.Options}-card__close-button`, 'close-button-cross')
              .event('click', () => {
                popUp.event('animationend', () => {
                  popUp.remove();
                })

                popUp.addClass('close');
              })
              .appendTo(popUp.DOMElement);

          new BaseElement(block.cloneNode(true))
              .appendTo(popUp.DOMElement);

          zoom();
        })
        .addAttribute('src', planURL);
    const print = cardBox.querySelector(`.${CardTypes.Options}-card__print-btn`);
    if (!print)
      if (config.features.apartments.isPrint && !isMobile && !isDesktop)
        addPrintButton(cardBox);

    addPaintButton(cardBox,planURL);
    block.classList.add('zoom');
    addActionsWith2DPlan('2D', element, isMobile);

    if(!isMobile && !config.features.apartments.hasPadding && !block.classList.contains('is-padding'))
      block.classList.add('is-padding');
  } else {
    preview.addAttribute('src', src);
    if (block.classList.contains('is-padding'))
      block.classList.remove('is-padding');
  }
}

export const addDisclaimer = (cardBox, element) => {
  const optionsCardsBox = element.closest('.options-card__plans-box');
  const previousDisclaimer = optionsCardsBox.querySelector('.options-card__disclaimer') || null;
  if (previousDisclaimer)
    previousDisclaimer.remove();

  let selectedMesh;
  if (cardsData.cardMode.isAmenities) {
    selectedMesh = null;
  } else {
    selectedMesh = findSelectionAndCrmData(cardBox.getAttribute('data-engineId')).selectedMesh;
  }

  const legalComments = selectedMesh ? selectedMesh.userData.crm_data.assets.legalComments : null;
  const dataType = element.getAttribute('data-type');
  let disclaimerText;
  switch(dataType) {
    case 'keyPlan':
    case '2D':
      disclaimerText = legalComments?.plan2D.find(obj => obj.lang === 'en')?.value
        ? legalComments?.plan2D
        : '2dDisclaimer';
      break;
    case '360Sample':
      disclaimerText = legalComments?.tours360.find(obj => obj.lang === 'en')?.value
        ? legalComments?.tours360
        : '360sampleDisclaimer';
      break;
    case '360':
      disclaimerText = legalComments?.tours360.find(obj => obj.lang === 'en')?.value
        ? legalComments?.tours360
        : '360Disclaimer';
      break;
    case 'vantage':
      disclaimerText = legalComments?.[dataType]?.find(obj => obj.lang === 'en')?.value
        ? legalComments?.[dataType]
        : 'vantageDisclaimer';
      break;
    case 'gallery':
      disclaimerText = legalComments?.[dataType]?.find(obj => obj.lang === 'en')?.value
        ? legalComments?.[dataType]
        : 'optionsCardGalleryDisclaimer';
      break;
  }

  new Disclaimer(optionsCardsBox, disclaimerText, 'options-card__disclaimer');
}

const setPlugToPreviewBlock = (cardBox) => {
  const block = cardBox.querySelector(`.${CardTypes.Options}-card__plans-box_preview`);
  if (!cardBox.querySelector(`.${CardTypes.Options}-card__plans-box_preview`).hasChildNodes()) {
    new BaseElement()
      .addClass(`${CardTypes.Options}-card__plans-box_preview-empty`)
      .innerHtml('Content will be soon')
      .appendTo(block);
  }
}

const addActiveClassToBtnTogglersPlans = (buttons) => {
  const firstButton = buttons.children[0];
  if (!firstButton || !buttons)
    return;

  firstButton.classList.add('active');
  if (firstButton.getAttribute('data-type') === 'vantage' && !isCompareMode())
    vantageSwitcher?.show();

  if (!isMobile)
    setActiveLordIcon(firstButton.getAttribute('lord-icon-name'), buttons);
}

const togglePlans = (cardBox) => {
  const btnBlock = cardBox.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`);
  btnBlock.addEventListener('click', togglePlansHandler.bind(this, cardBox));
};

export function getFloorAmenitiesFromCommonAssets (object) {
  if (typeof settingsData.commonAssets === 'object') {
    const amenities = settingsData.commonAssets[object.buildingEngineId]?.floorAmenities;
    if (amenities) {
      const data = amenities.find(floor => object.floorNum >= Number(floor.from) && object.floorNum <= Number(floor.to));
      if (data) {
        return data.assets.plan2D;
      }
    }
  }
}

const addPlansData = (object) => {
  let settingArray = JSON.parse(JSON.stringify(config.property.buttons));
  const hideButtons = config.features.apartments.excludeButtons;
  if (!cardsData.cardMode.isAmenities) {
    const keyPlan = getFloorAmenitiesFromCommonAssets(object);

    if (keyPlan) {
      object.assets.keyPlan = keyPlan;
      settingArray.push({
        type: 'keyPlan',
        active: true
      });
    }
  }

  if (hideButtons) {
    settingArray = settingArray.filter(btn => !hideButtons.includes(btn.type));
  }

  const iconsArray = createIconsArray();
  let flag360;
  let plansArray = settingArray.map(data => {
    const dataConfig = iconsArray.find(prop => prop.type === data.type);
    const crmData = Boolean(object) ? object?.assets[dataConfig.crmTitle] : null;
    let obj = {
      type: data.type,
      crmData,
      icon: dataConfig.icon,
      isActive: data.active,
    };

    if (data.type === '360' && Boolean(obj.crmData))
      flag360 = true;

    return obj;
  });

  if (flag360)
    plansArray = plansArray.filter(btn => btn.type !== '360Sample');

  return plansArray;
};

const addActionsWith2DPlan = (buttonText, btn) => {
  if (buttonText === '2D') {
    zoom();
    btn.classList.add('active');
  }
};

const addPrintButton = (cardBox) => {
  if (cardBox.querySelector('.print') || isCompareMode())
    return;

  const plansBoxButtons = cardBox.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`);
  const printBtn = new BaseElement('button')
    .addClass(`${CardTypes.Options}-card__plans-box_buttons-btn`, 'print')
    .event('click', print2DPlan.bind(this, cardBox))
    .appendTo(plansBoxButtons)
    .DOMElement;

  addCardButtonTooltip(printBtn,'Print');

  setLordIcon('print', printBtn, {
    stroke: 90,
    trigger: 'hover'
  });
};

export function addCardButtonTooltip (element,key) {
  let type;

  switch (key) {
    case '360':
      type = 'Tours';
      break;
    case '2D':
      type = '2DPlan';
      break;
    case 'vantage':
      type = 'Vantage';
      break;
    case 'keyPlan':
      type = 'Key plan';
      break;
    default:
      type = key;
      break;

  }

  new BaseElement('span')
      .addClass(`${CardTypes.Options}-card__plans-box_buttons-tooltip`,'language-string')
      .addAttribute('data-dictionary',type)
      .innerHtml(changeLangToCurrent(type))
      .appendTo(element);
}

const addPaintButton = (cardBox) => {
  const engineId = cardBox.getAttribute('data-engineid');
  let isFloorPlan = engineId.startsWith('zero');
  if ((cardBox.classList.contains('amenities-card') && !isFloorPlan) || cardBox.querySelector('.paint-2d') || config.features.apartments.isPaint === false)
    return;

  const plansBoxButtons = cardBox.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`);
  const paintBtn = new BaseElement('button')
    .addClass(`${CardTypes.Options}-card__plans-box_buttons-btn`, 'paint-2d', isMobile ? 'icon-pencil' : null)
    .event('click', () => {
      const img = cardBox.querySelector('img');
      const imgURL = img.getAttribute('src');
      isFloorPlan = engineId.startsWith('zero') || img.classList.contains('plan-keyPlan');
      if (isFloorPlan) {
        const crmDataOfFloor = Buildings.activeBuilding.apartments.find(obj => obj.userData.crm_data.floorNum === settingsData.currentFloor)?.userData.crm_data;
        analytics('floor_plan_paint',crmDataOfFloor);
      } else {
        const {crmDataOfFlat} = findSelectionAndCrmData(engineId);
        analytics('plan_paint',crmDataOfFlat);
      }
      new Paint(imgURL);
    })
    .appendTo(plansBoxButtons)
    .DOMElement;

  addCardButtonTooltip(paintBtn,'Draw');

  !isMobile && setLordIcon('edit2', paintBtn, {
    stroke: "bold",
    trigger: 'hover'
  });
};

const print2DPlan = async (cardBox) => {
  const engineId = cardBox.getAttribute('data-engineid');
  let resize;
  if (engineId.split('_')[0] === 'zero') {
    resize = cardBox.querySelector('img.plan-2D').getAttribute('src');
  } else if (engineId) {
    const crm = settingsData.allCrmData.find(obj => obj.engineId === engineId);
    // resize = Cloudflare.resize(crm.assets.plan2D,{
    //   height: 700
    // });
    const img = cardBox.querySelector('img');
    if (img.classList.contains('plan-2D')) {
      resize = crm.assets.plan2D;
    } else if (img.classList.contains('plan-keyPlan')) {
      resize = crm.assets.keyPlan;
    }
}

  resize = resize.replace(/resize\/image\/width=\d+\//, '').replace(/\?v=\d+/, '');
  resize = Cloudflare.resize(resize,{
    height: 850
  });

  const {cdnRepository,projectFolder, features} = config;
  const logoUrl = `${cdnRepository}/${projectFolder}/resources/img/logo.png`;
  const imageExists = await checkImageExists(logoUrl);
  const logoUrlResized = imageExists ? Cloudflare.resize(logoUrl, { height: 100 }) : '';

  printJS({
    printable: decodeURI(resize),
    type: 'image',
    header: `<div class="printjs-custom-header"><h3>${config.features?.printHeader?.title || ''}</h3>${imageExists ? `<img src="${logoUrlResized}" alt="Logo" />` : ''}</div>`,
    style: '.printjs-custom-header { display: flex; flex-direction: row; justify-content: flex-end; align-items: center; gap: 20px; font-family: "Arial"; margin-bottom: 60px; margin-right: 20px;}'
  });

  // printJS(decodeURI(resize), 'image');
}

const addBackButton = (parent) => {
  if (document.querySelector('.plan-back_btn'))
    return;

  const button = new BaseElement('button')
    .addClass(
      `${CardTypes.Options}-card__plans-box_buttons-btn`,
      'search__round-button',
      'plan-back_btn',
      'icon-back',
      'hidden'
    )
    .addAttribute('data-type', 'Back')
    .event('click', optionsCardBackButtonHandler)
    .appendTo(parent);

  appearPlansButtonAnimation(button.DOMElement);
}

/**
 * Handlers
 */

async function optionsCardBackButtonHandler() {
  hideAbsentInConfigUnitCardInfoPoints();
  projectMode.Pagination.paginate({source: 'cardsBackButton'});
  if (Vantages.isActive()) {
    Vantages.close(() => {
      allPlansButtonsDisappear();
      closeOptionsCard();
        if (isMobile) {
            if (settingsData.activeViewMode !== ViewMode.FloorPlan) {
                UnitCardClass.closeMobileCard();
            } else {
                Amenities.hide();
            }
            // components.mobileSearch.focusOnActiveCard();
        }
    });
  } else {
    setTimeout(() => {
      allPlansButtonsDisappear();
      closeOptionsCard();

      if (isMobile) {
        if (settingsData.activeViewMode !== ViewMode.FloorPlan)
          UnitCardClass.closeMobileCard();

        // components.mobileSearch.focusOnActiveCard();
      }



    }, 100);
  }
}

/**
 * Handlers
 */

export function closeHandler() {
  if (Vantages.isActive()) {
    Vantages.close(() => {
      closeOptionsCard();
      Amenities.createSwiper();
      if (settingsData.activeViewMode === ViewMode.FloorPlan)
        Amenities.hide();
    });
  } else {
    closeOptionsCard();
  }
}

export const applyNowHandler = () => {
  if (settingsData.showApplyNow)
    applyNow(
      document.body,
      applyNowContent,
      false,
      ['print-btn', 'popup-btn.icon-close'],
      settingsData.lastClickedFlat
    );
}

export const togglePlansHandler = (cardBox, e) => {
  console.warn('togglePlansHandler');
  e.stopPropagation();
  if (userPrevent()) return;
  if (cardsData.cardMode.isAmenities || (cardsData.cardMode.isAmenities && e.target.classList.contains('options-card__close-btn')) || e.target.closest('.traverse-switcher') || e.target.classList.contains('plan-back_btn') || e.target.closest('.vantage-mode-btn') || e.target.classList.contains('paint-2d'))
    return;

  if (e.target.closest('.vantage')) {
    vantageSwitcher ?
      vantageSwitcher.show() : null;
  } else {
    vantageSwitcher ?
      vantageSwitcher.hide() : null;
  }

  if (!e.target.classList.contains('traverse-switcher__control-button') && vantageSwitcher)
    vantageSwitcher.setCurrentFloorButtonInFocus();

  let target = e.target.tagName === 'BUTTON' ? e.target : e.target.parentElement;

 if (target.classList.contains('paint-2d') || !target.getAttribute('data-type')) return;

  const engineId = cardBox.getAttribute('data-engineid');
  if (engineId.split('_')[0] === 'zero')
    return;

  const {crmDataOfFlat} = findSelectionAndCrmData(engineId);
  const plansData = addPlansData(crmDataOfFlat);
  const sortingArray = plansData.reduce((arr, data) => {
    const elem = data.type === '360' ? data : null;
    elem ? arr.unshift(data) : arr.push(data);

    return arr;
  }, []);

  removeOptionsCardGallery();

  // const block = cardBox.querySelector(`.${CardTypes.Options}-card__plans-box_preview`);
  const block =
      e.target.closest(`.${CardTypes.Options}-card`).querySelector(`.${CardTypes.Options}-card__plans-box_preview`);
  block.removeAttribute('style');

  if (target === cardBox.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`)
    || target.classList.contains('print')
    || target.classList.contains('download')
    || target.classList.contains('plan-back_btn'))
    return;

  if (Vantages.isActive()) {
    Vantages.close(undefined,engineId);
  }
  // Vantage.globalHandler('plan-box-element');

  const btnList = cardBox.querySelectorAll(`.${CardTypes.Options}-card__plans-box_buttons-btn`);
  createPlanPreviewElement( {cardBox, element: target, block, plansData: sortingArray} );

  if (!target.classList.contains('2D') && !target.classList.contains('keyPlan')) {
    cardBox.querySelector('.print') && cardBox.querySelector('.print').remove();
    cardBox.querySelector('.paint-2d') && cardBox.querySelector('.paint-2d').remove();
    cardBox.querySelector('.download') && cardBox.querySelector('.download').remove();
    cardBox.querySelector(`.${CardTypes.Options}-card__plans-box_preview`).removeAttribute('style');
  }

  btnList.forEach(btn => {
    if (btn.classList.contains('active')) {
      btn.classList.remove('active');
      if (!isMobile) {
        btn.removeAttribute('disabled');
        setActiveLordIcon(undefined, cardBox.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`));
      }
    }
  });

  if (!isMobile)
    target.setAttribute('disabled', 'disabled');

  target.classList.add('active');

  if (!isMobile)
    setActiveLordIcon(target.getAttribute('lord-icon-name'), cardBox.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`));
}

const swipeRightDataHandler = (e) => {
  draggableOptionsCardBlock(e, 'close');
}

const swipeLeftDataHandler = (e) => {
  draggableOptionsCardBlock(e, 'open');
}

/**
 * Remove all listeners
 */

export const removeOptionCardListeners = () => {
  const closeButton = document.querySelector(`.${CardTypes.Options}-card__close-btn`);
  closeButton?.removeEventListener('click', closeHandler);

  const applyNowButton = document.querySelector(`.${CardTypes.Options}-card__apply-now-btn`);
  applyNowButton?.removeEventListener('click', applyNowHandler);

  const btnBlock = document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`);
  btnBlock?.removeEventListener('click', togglePlansHandler);

  const cardBoxData = document.querySelector(`.${CardTypes.Options}-card__data`);
  if (cardBoxData) {
    cardBoxData.removeEventListener('swiped-right', swipeRightDataHandler);
    cardBoxData.removeEventListener('swiped-right', swipeLeftDataHandler);
    cardBoxData.removeEventListener('swiped-left', swipeLeftDataHandler);
    cardBoxData.removeEventListener('swiped-left', swipeRightDataHandler);
    cardBoxData.removeEventListener('click', draggableOptionsCardBlock);
  }

  const optionsCard = document.querySelector(`.${CardTypes.Options}-card`);
  if (isMobile && optionsCard)
    optionsCard.removeEventListener('scroll', scroll);
}

export function renameTowerNameInOptionCard() {
  const card = document.querySelector(`.${CardTypes.Options}-card`);
  if (Buildings.getBuildingsInfoLength() <= 1 || !card)
    return;


  const towerName = card.querySelector('.card__tower-name');
  const activeBuildingTowerName = Buildings.getActiveBuilding().info.towerName;
  let name;

  Array.isArray(activeBuildingTowerName) ?
    name = activeBuildingTowerName.find(name => name.lang === getCurrentLang()).value:
    name = activeBuildingTowerName;

  !isStringHasChars(name) ?
    towerName.textContent = name + ' ' + changeLangToCurrent('building'):
    towerName.textContent = name;
}

export function resizeOptionsCardGallery() {
  if (optionCardGallery !== null)
    optionCardGallery?.update();
}

export function removeOptionsCardGallery() {
  if (optionCardGallery !== null) {
    optionCardGallery.remove();
    optionCardGallery = null;
  }
}

export function changeOptionsCardGalleryDirection() {
  if (optionCardGallery)
    optionCardGallery.changeDirection();
}
